import { faqItems } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            常见问答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于51黑料网的常见问题，这里都有解答
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group border border-background-200/70 rounded-xl bg-background-50 cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-500 group-open:text-white transition-colors flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}